"use client";

import * as React from "react";

import {
  Sheet,
  SheetContent,
} from "@replo/design-system/components/shadcn/core/sheet";
import { useIsMobile } from "@replo/design-system/components/shadcn/hooks/use-mobile";
import clsxMerge from "@replo/design-system/components/shadcn/utils/cn-merge";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  children: React.ReactNode;
  className?: string;
};

export function MobileSheet({
  open,
  onOpenChange,
  children,
  className,
}: Props) {
  const isMobile = useIsMobile();

  if (!isMobile) {
    return null;
  }

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="bottom"
        className={clsxMerge(
          "inset-x-0 bottom-0 p-0 overflow-y-auto border-t border-border rounded-t-xl pb-[env(safe-area-inset-bottom)] [&>button]:hidden bg-white max-h-[85svh]",
          className,
        )}
      >
        {children}
      </SheetContent>
    </Sheet>
  );
}
